/* eslint-disable no-restricted-globals */
const firebaseConfigs = {
    development: {
        apiKey: 'AIzaSyAvEnr4De3yogkLhEm7q3dj8wu8I41MQtY',
        authDomain: 'develop-mifinca-2022.firebaseapp.com',
        projectId: 'develop-mifinca-2022',
        storageBucket: 'develop-mifinca-2022.appspot.com',
        messagingSenderId: '315185513647',
        appId: '1:315185513647:web:fa9890901ddcca9fe3c05a',
        measurementId: 'G-H83YXBQRLY'
    },
    production: {
        apiKey: 'AIzaSyBxhcKG8vPW6GZCQOlGkKrmjvX3cuP8kqU',
        authDomain: 'mifinca-2022.firebaseapp.com',
        projectId: 'mifinca-2022',
        storageBucket: 'mifinca-2022.appspot.com',
        messagingSenderId: '1005654960757',
        appId: '1:1005654960757:web:a0f7c0c061fb37c436663c',
        measurementId: 'G-ELTT88ZLF7'
    }
};

let firebaseEnv = 'none';
if (window && location) {
    if (/develop/.test(location.href) || /localhost/.test(location.href)) {
        firebaseEnv = 'development';
    }
    if (
        location.origin === 'https://stage-mifinca.web.app' ||
        location.origin === 'https://mifinca.web.app'
    ) {
        firebaseEnv = 'production';
    }
}

export default firebaseConfigs[firebaseEnv];
